import React from "react";
import { Link } from "gatsby";
import { ExternalLink } from "~/atoms/ExternalLink";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import logoHorizontal from "~/images/logo-horizontal.svg";

type Props = {
  isTopPage?: Boolean;
};

export const Footer: React.FC<Props> = ({ isTopPage = false }) => {
  return (
    <>
      <style jsx>{`
        .wrapper {
          background-color: ${(isTopPage && colors.lightGray) || colors.white};
          color: ${colors.defaultText};
          padding: 60px 30px 30px;
          font-family: "Noto Sans JP", sans-serif;
        }
        .container {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          margin: 0 auto;
          max-width: 1400px;
        }
        .logo {
          display: block;
          height: 32px;
          width: auto;
          flex-shrink: 0;
          margin-right: 60px;
        }
        .logo :global(img) {
          display: block;
          height: 32px;
          width: auto;
        }
        .navigations {
          display: flex;
          flex-wrap: nowrap;
        }
        .navigation + .navigation {
          margin-left: 30px;
        }
        .navigationTitle {
          font-size: 13px;
          font-weight: 700;
          margin: 0;
        }
        .navigationList {
          margin-top: 10px;
          list-style: none;
          padding: 0;
        }
        .navigationListItem {
          font-size: 13px;
          margin-top: 5px;
        }
        .navigationListItem :global(a),
        .navigationListItem :global(a:visited),
        .navigationListItem :global(a:active) {
          color: ${colors.defaultText};
        }
        .navigationListItem :global(a:hover) {
          text-decoration: underline;
        }
        .navigationListItem :global(a .en) {
          font-size: 1.16em;
        }
        .copyright {
          display: flex;
          justify-content: center;
          margin-top: 50px;
        }
        .copyrightText {
          font-size: 11px;
          text-align: center;
          line-height: 1;
        }
        @media (${breakPoints.sp}) {
          .wrapper {
            padding: 40px 20px 20px;
          }
          .container {
            flex-direction: column;
            align-items: flex-start;
          }
          .logo {
            margin-bottom: 30px;
            margin-right: 0;
            align-self: flex-start;
          }
          .navigations {
            width: 100%;
            flex-direction: column;
            gap: 30px;
          }
          .logo + .navigation,
          .navigation + .navigation {
            margin-left: 0;
          }
          .navigation {
            width: 100%;
          }
          .navigationTitle {
            font-size: 14px;
            margin-bottom: 8px;
          }
          .navigationList {
            margin-top: 8px;
          }
          .navigationListItem {
            font-size: 14px;
            margin-top: 8px;
            line-height: 1.6;
          }
          .copyright {
            margin-top: 40px;
          }
        }
      `}</style>
      <footer className="wrapper">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img src={logoHorizontal} alt="Refcome" />
            </Link>
          </div>
          <div className="navigations">
            <nav className="navigation">
              <h2 className="navigationTitle">
                <span className="en">サービスについて</span>
              </h2>
              <ul className="navigationList">
                <li className="navigationListItem">
                  <Link to="/cases">導入事例</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/request">サービス資料のご請求</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/inquiry/contact">サービスに関するお問い合わせ</Link>
                </li>
              </ul>
            </nav>
            <nav className="navigation">
              <h2 className="navigationTitle">セミナー・イベント</h2>
              <ul className="navigationList">
                <li className="navigationListItem">
                  <Link to="/events/seminar">セミナー情報</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/events/award">Referral Recruiting Award</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/events/report">イベントレポート</Link>
                </li>
              </ul>
            </nav>
            <nav className="navigation">
              <h2 className="navigationTitle">リファラル採用について</h2>
              <ul className="navigationList">
                <li className="navigationListItem">
                  <Link to="/downloads">お役立ち資料</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/insight">ブログ</Link>
                </li>
              </ul>
            </nav>
            <nav className="navigation">
              <h2 className="navigationTitle">規約</h2>
              <ul className="navigationList">
                <li className="navigationListItem">
                  <Link to="https://refcome.team/terms">利用規約</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/privacy">個人情報の取り扱いについて</Link>
                </li>
                <li className="navigationListItem">
                  <Link to="/privacy/statement">個人情報保護方針</Link>
                </li>
              </ul>
            </nav>
            <nav className="navigation">
              <h2 className="navigationTitle">私たちについて</h2>
              <ul className="navigationList">
                <li className="navigationListItem">
                  <ExternalLink to="https://willof-partner.co.jp/company">会社概要</ExternalLink>
                </li>
                <li className="navigationListItem">
                  <ExternalLink to="https://willof-partner.co.jp/contact">会社へのお問い合わせ</ExternalLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="copyright">
          <small className="copyrightText">Copyright © WILLOF PARTNER, Inc. All rights reserved.</small>
        </div>
      </footer>
    </>
  );
};
